// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general_drop_box {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    background-color: #D6D6DF;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    cursor: pointer;
}
.general_drop_box_open {
    width: 100%;
    border-radius: 5px;
    background-color: #D6D6DF;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    cursor: pointer;
    padding-bottom: 10px;
}
.space-between_drop {
    width: 100%;
    height: 100%;
    min-height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.general_drop_plus {
    margin-right: 1rem;
    width: 15px;
    height: 15px;
    position: relative;
    transition: 0.3s;
    cursor: pointer;
}
.general_line_one {
    width: 100%;
    min-height: 3px;
    height: 3px;
    background-color: black;
    position: absolute;
    left: 0;
    top: calc(50% - 3px);
}
.general_line_two {
    width: 100%;
    height: 3px;
    min-height: 3px;
    background-color: black;
    position: absolute;
    left: 0;
    top: calc(50% - 3px);
    transform: rotateZ(90deg);
    transition: 0.3s;
}
.general_line_two_clicked {
    width: 100%;
    height: 3px;
    background-color: black;
    position: absolute;
    left: 0;
    top: calc(50% - 3px);
    transform: rotateZ(0);
    transition: 0.3s;
}
.drop_data > p {
    font-size: 0.8rem;
    color: #4a4747;
    font-weight: 600;
    margin-bottom: 10px;
}
.drop_data > h4 {
    font-size: 1.1rem;
    font-weight: 600;
}
.general_drop_grid {
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: grid;
    grid-row-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr;
}
.general_item_box {
    padding: 10px 7px;
    background-color: #BABAC6;
    margin-right: 2rem;
    border-radius: 5px;
    transition: 0.3s;
}

.branch_input {
    border: none;
    background-color: white;
    height: 28px;
    padding-left: 5px;
    border-radius: 5px;
    outline: none;
    font-size: 16px;
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    color: #292452;
}

`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/GeneralDropdown.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".general_drop_box {\n    width: 100%;\n    height: 50px;\n    border-radius: 5px;\n    background-color: #D6D6DF;\n    margin-bottom: 1rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    cursor: pointer;\n}\n.general_drop_box_open {\n    width: 100%;\n    border-radius: 5px;\n    background-color: #D6D6DF;\n    margin-bottom: 1rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    cursor: pointer;\n    padding-bottom: 10px;\n}\n.space-between_drop {\n    width: 100%;\n    height: 100%;\n    min-height: 50px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.general_drop_plus {\n    margin-right: 1rem;\n    width: 15px;\n    height: 15px;\n    position: relative;\n    transition: 0.3s;\n    cursor: pointer;\n}\n.general_line_one {\n    width: 100%;\n    min-height: 3px;\n    height: 3px;\n    background-color: black;\n    position: absolute;\n    left: 0;\n    top: calc(50% - 3px);\n}\n.general_line_two {\n    width: 100%;\n    height: 3px;\n    min-height: 3px;\n    background-color: black;\n    position: absolute;\n    left: 0;\n    top: calc(50% - 3px);\n    transform: rotateZ(90deg);\n    transition: 0.3s;\n}\n.general_line_two_clicked {\n    width: 100%;\n    height: 3px;\n    background-color: black;\n    position: absolute;\n    left: 0;\n    top: calc(50% - 3px);\n    transform: rotateZ(0);\n    transition: 0.3s;\n}\n.drop_data > p {\n    font-size: 0.8rem;\n    color: #4a4747;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n.drop_data > h4 {\n    font-size: 1.1rem;\n    font-weight: 600;\n}\n.general_drop_grid {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    display: grid;\n    grid-row-gap: 10px;\n    grid-template-columns: 1fr 1fr 1fr;\n}\n.general_item_box {\n    padding: 10px 7px;\n    background-color: #BABAC6;\n    margin-right: 2rem;\n    border-radius: 5px;\n    transition: 0.3s;\n}\n\n.branch_input {\n    border: none;\n    background-color: white;\n    height: 28px;\n    padding-left: 5px;\n    border-radius: 5px;\n    outline: none;\n    font-size: 16px;\n    font-family: Montserrat, sans-serif;\n    font-weight: 600;\n    color: #292452;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
